import React from 'react'
import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import { CMSState } from '../../../../cms/blocks/types.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { useState } from 'react'
import { wysiwyg } from '../../../templates/wysiwyg.mod'

export type TextBlockProps<CustomBlockData, extra_images> = {
  title?: string
  text: string
}

export type TextBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  text_classname: string
  footer_classname: string
  clickable_primary_classname: string
  clickable_secondary_classname: string
}>

export function TextBlock<CustomBlockData, extra_images>(
  props: TextBlockProps<CustomBlockData, extra_images>,
  options?: { style?: TextBlockStyle; key?: string }
): IOWidget<CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>, Action<CMSState<CustomBlockData, extra_images, never>>> {
  return (s: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: onDone => (
        <TextBlockComponent textProps={props} options={options} cmssState={s} />
      )
    })
}

type Props<CustomBlockData, extra_images> = {
  textProps: TextBlockProps<CustomBlockData, extra_images>
  options: { style?: TextBlockStyle; key?: string }
  cmssState: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>
}

function TextBlockComponent<CustomBlockData, extra_images>(props: Props<CustomBlockData, extra_images>) {
  const [expanded, setExpanded] = useState(false)
  
  return (
    <section
      className={`block block--text`}
      key={props.options && props.options.key ? props.options.key : 'text-block'}
    >
      <div className="block__inner container--xs grid--spacing">
      {props.textProps.title &&
        <header className="block__header">
          <h2 className="block__title typo--3xl">{props.textProps.title}</h2>
        </header>
      }          

        <div className="block__content">
          { wysiwyg({ 
            className:"block__text text--styled"
          })(props.textProps.text).run(_ => {}) }
        </div>

      </div>
    </section>
  )
}